import React from "react";
import { graphql, useStaticQuery } from "gatsby";
import Img from "gatsby-image";
import { Container, Row, Col } from "react-bootstrap";
import { WMKLink } from "wmk-lib";
import styled from "styled-components";
import { BackToMain } from "../../common";
import { H4, Intro } from "../../common";
import get from "lodash/get";

const Styled = {};
Styled.ArchivedReport = styled(Col)`
  display: flex;
  justify-content: center;
  padding: 1rem;
  .wmk-link {
    display: flex;
    justify-content: center;
    padding-bottom: 1rem;
    flex-direction: column;
  }
`;

const Archives = ({ page }) => {
  const { reports } = useStaticQuery(archiveQuery).archives;
  const { title } = page;
  return (
    <Container>
      <Intro title={title} backlink="/" />
      <Row style={{ paddingBottom: "6vh" }}>
        {reports.map((report) => {
          return (
            <Styled.ArchivedReport
              key={get(report, `title`)}
              xs={12}
              sm={12}
              md={6}
              lg={4}
            >
              <WMKLink to={get(report, `pdf.file.url`)} target="_blank">
                <Img
                  fixed={get(report, `img.fixed`)}
                  alt={get(report, `img.title`)}
                />
                <H4>{get(report, `title`)}</H4>
              </WMKLink>
            </Styled.ArchivedReport>
          );
        })}
      </Row>
      <BackToMain />
    </Container>
  );
};

export default Archives;

const archiveQuery = graphql`
  {
    archives: contentfulMenus(title: { eq: "Archived Reports" }) {
      reports: menuItems {
        ... on ContentfulLinks {
          pdf: asset {
            file {
              url
            }
            title
          }
          img: assetImage {
            fixed(width: 330, height: 220, resizingBehavior: PAD) {
              ...GatsbyContentfulFixed_withWebp
            }
            title
          }
          title
        }
      }
    }
  }
`;
